import { User } from 'oidc-client-ts';
import { Loadable } from '../..';
import { getClaims } from '../../loginDetails';
import { UserRoles } from '../userRolesState';

export enum AspNetRole {
  Cellhire = 'Cellhire',
  CellhireSuperUser = 'CellhireSuperUser',
  CellhireAirtime = 'CellhireAirtimeAdministrator',
  PortalAdmin = 'Portal Admin'
}

export function hasAspNetRole(user: User | undefined, roleName: AspNetRole) {
  const claimRole = user && getClaims(user).role;
  const role: string[] | undefined = typeof claimRole === 'string' ? [claimRole] : claimRole;
  if (role) {
    return role.includes(roleName);
  }

  return false;
}

export enum Role {
  CellhireAirtime = 'cellhire-airtime',
  ConfigBmDefaults = 'config-bm-defaults',
  AssignAlertManager = 'assign-alert-manager',
  MigrateIn = 'migrate-in',
  PortIn = 'port-in',
  Provision = 'provision',
  SmsAlertsConfig = 'sms-alerts-config',
  SpendCapAdmin = 'spend-cap-admin',
  SuperAdmin = 'super-admin',
  SimOrdering = 'sim-ordering',
  SessionInfo = 'session-info',
  PortingWizard = 'porting-wizard',
  PortalAdmin = 'create-group',
  ImeiLock = 'imei-lock',
  SendSms = 'send-sms'
}

export function hasRole(userRoles: Loadable<UserRoles> | undefined, roles: Role[]) {
  if (!userRoles) {
    return false;
  }

  if (userRoles.byId[Role.SuperAdmin]) {
    return true;
  }

  for (const role of roles) {
    if (userRoles.byId[role]) {
      return true;
    }
  }

  return false;
}
